// @flow

export const SAM_START = 'SAM_START';
export const SAM_SUCCESS = 'SAM_SUCCESS';
export const SAM_FAILURE = 'SAM_FAILURE';
export const SAM_CLOSE = 'SAM_CLOSE';

export const samSuccess = data => ({ type: SAM_SUCCESS, payload: data });


const closeSam = () => ({ type: SAM_CLOSE });

export const closeSysWarn = () => (dispatch) => {
  dispatch(closeSam());
};

export const defaultState = {
  sysdownmessage: {
    msgid: '',
    typecode: '',
    title: '',
    message: '',
    startdate: new Date(),
    enddate: new Date(),
    description: '',
    archived: '',
  },
  syswarnmessage: {
    msgid: '',
    typecode: '',
    title: '',
    message: '',
    startdate: new Date(),
    enddate: new Date(),
    description: '',
    archived: '',
  },
  fetching: false,
  samClosed: false,
};

const SamReducer = (state: Object = defaultState, action: Object = {}) => {
  let { samClosed } = state;
  switch (action.type) {
    case SAM_CLOSE:
      return Object.assign({}, state, {
        samClosed: true,
      });
    case SAM_START:
      return Object.assign({}, state, {
        fetching: true,
      });
    case SAM_SUCCESS:
      if (action.payload.typeCode === 'SYSDOWN') {
        if (state.sysdownmessage && state.sysdownmessage.msgId !== action.payload.msgId) {
          samClosed = false;
        }
        return Object.assign({}, state, {
          sysdownmessage: action.payload,
          fetching: false,
          samClosed,
        });
      }

      if (action.payload.typeCode === 'SYSWARN') {
        if (state.syswarnmessage && state.syswarnmessage.msgId !== action.payload.msgId) {
          samClosed = false;
        }
        return Object.assign({}, state, {
          syswarnmessage: action.payload,
          fetching: false,
          samClosed,
        });
      }
      return state;
    case SAM_FAILURE:
      return Object.assign({}, state, {
        fetching: false,
        error: action.payload,
      });
    default:
      return state;
  }
};

export default SamReducer;
